module.exports = __webpack_public_path__ + "img/eight.e43dd258.png";